import React, { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ButtonMain from '../../components/common/ButtonMain';
import { ReactComponent as RegistrationIllustration } from '../../assets/images/registration.svg';

function RegistrationComplete() {
  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );

  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );

  useEffect(() => {
    toast.success(t.ACTIVATE_MSG_NOTIFICATION, {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
    });
  }, [t.ACTIVATE_MSG_NOTIFICATION]);

  return (
    <div className="SignUp-main-container">

      <div className="inputDivStyle-signup">
        <div className="Registration-Illustration">
          <RegistrationIllustration />
        </div>
        <div className="textDiv">
          <p className="text__create_Illustration">{t.REGISTRATION_COMP}</p>
          <p className="text__start_Illustration">{t.ACTIVATE_LINK}</p>
        </div>
        <div>
          <Link
            to="/login"
            style={{ textDecoration: 'none', paddingLeft: '5px' }}
          >
            <ButtonMain title="Back to Login" className="buttonStyleEnable" />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default RegistrationComplete;
